module.exports = __webpack_public_path__ + "static/media/pause.51b90f6e.svg";